
import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Box, Paper, IconButton, Stack, Typography, Tooltip, Checkbox } from "@mui/material";
import Draggable from "../../extra2/Draggable";
import VideoViewer from "../../extra2/VideoViewer";
import ImageViewer from "../../extra2/ImageViewer";
import XDateCalendar from "../extra/XDateCalendar";

import { LATESTFILE, VIDEO, TLVIDEO, SENDEMAIL, LATESTDAYFILE, PRESET } from "../../services/actions";
import './main.css'
import {
    ChevronDownIcon, ChevronUpIcon, ChevronRightIcon,
    ChevronLeftIcon, CameraControlIcon, Calendar24,
    ChangeVideo24, Weather24, Share24, Markup24, SplitViewIcon,
    Timelapse24, ZoomInIcon, ZoomOutIcon, ChevronBackwardIcon, ChevronForwadIcon,
    SplitViewBlackIcon
} from "./icons/Icons";
import { FaChevronRight, FaChevronLeft, FaHome } from "react-icons/fa";
import TopBar from "./TopBar";
import {
    shareIcon, viewsIcon, DropDown, DateBar,
    formatLatLng, printImage, downloadImage
} from './Tools'
import CompareMonth from "./sub_views/CompareMonth";
import SplitPreview from "./sub_views/SplitPreview";
import DiffPreview from "./sub_views/DiffPreview";
import SpotCompare from "./sub_views/SpotCompare";
import SpotZoom from "./sub_views/SpotZoom";
import VectorMap from "../extra/VectorMap";
import WeatherCard from "../extra/WeatherCard";
import Photoshop from "./sub_views/markup/Photoshop";
import overlayLogo from '../../layouts/Widelapse Logo White.png'
import VideoPlayer2 from "./sub_views/VideoPlayer2";
import PDFReport from "./sub_views/PDFReport";
import ShareBox from "../extra/ShareBox";
import DeepZoomModal from "../extra/DeepZoomModal";
import ThreeDStackViewer from "../extra/ThreeDStackViewer";
const resposive = { display: { xs: 'none', md: 'flex' } }
const flex = { display: 'flex', alignItems: 'center' }
const videoIcons = {
    prev: <ChevronLeftIcon />,
    next: <ChevronRightIcon />,
    move_prev: <ChevronLeftIcon />,
    move_next: <ChevronRightIcon />,
    move_up: <ChevronUpIcon />,
    move_down: <ChevronDownIcon />,
    center: <CameraControlIcon />,
    zoom_in: <ZoomInIcon />,
    zoom_out: <ZoomOutIcon />,
    backward: <ChevronBackwardIcon />,
    forward: <ChevronForwadIcon />,
}

export default function Video() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const locationState = location.state || {};
    let initialCamera = locationState.camera;
    let initialCameras = locationState.cameras;
    let initialVideoMode = locationState.video_mode;

    if (!initialCamera) {
        try {
            const saved = JSON.parse(sessionStorage.getItem('last_selected_camera') || 'null');
            if (saved?.camera) {
                initialCamera = saved.camera;
                initialCameras = saved.cameras || [];
                initialVideoMode = saved.video_mode !== undefined ? saved.video_mode : false;
            }
        } catch (e) { }
    } else {
        try {
            sessionStorage.setItem('last_selected_camera', JSON.stringify({
                camera: initialCamera,
                cameras: initialCameras,
                video_mode: initialVideoMode
            }));
        } catch (e) { }
    }

    const camera = initialCamera;
    const cameras = initialCameras;
    const [selectedCamera, setSelectedCamera] = useState(camera);
    const [videoMode, setVideoMode] = useState(Boolean(initialVideoMode));
    const video_mode = videoMode;

    const monthProgressState = useSelector(state => state?.latestdayfileState);
    const [showMenu, setShowMenu] = useState(true);
    const [imageData, setImageData] = useState({});
    const [imageData2, setImageData2] = useState({});
    const [showImage1, setShowImage1] = useState(false);
    const [showImage2, setShowImage2] = useState(false);
    const [changeView, setChangeView] = useState(0);
    const [toolChecked, setToolChecked] = useState(true)
    const videoViewerRef = useRef(null);
    const [snapshotImage, setSnapshotImage] = useState(null);
    const [showTimeline, setShowTimeline] = useState(false);
    const [deepZoomOpen, setDeepZoomOpen] = useState(false);
    const [show3DStack, setShow3DStack] = useState(false);

    useEffect(() => {
        if (!selectedCamera) return;
        if (videoMode) {
            const streamPath =
                selectedCamera?.stream_url ||
                selectedCamera?.video_url ||
                (selectedCamera?.id ? `/api/video/stream/?id=${selectedCamera.id}&_t=${Date.now()}` : "");

            if (streamPath) {
                setImageData(prev => ({ ...prev, currentImage: streamPath, type: "video" }));
                setShowImage1({ path: streamPath });
            }
            if (selectedCamera?.camera_type === "LIVETIMELAPSE") {
                onDateChange(undefined, 0, selectedCamera, false);
            }
        } else {
            onDateChange(undefined, 0, selectedCamera, true);
        }

    }, [selectedCamera, videoMode]);

    if (!camera) {
        return <Navigate to="/cameras/" replace />;
    }

    const formatCurrentImage = (imageData, key) => {
        if (!imageData || !imageData?.times || !imageData.times.length) return null;

        let index = (isNaN(key)) ? imageData?.utcMap?.get(key) : key;
        if (index === undefined || isNaN(index)) index = imageData.times.length - 1;
        index = Math.min(Math.max(0, index), imageData.times.length - 1);
        let item = imageData.times[index]
        let itemNext = imageData.times[Math.min((index + 1), imageData?.times?.length - 1)]
        let itemPrev = imageData.times[Math.max((index - 1), 0)]
        let cvtDateTime = item?.cvtDateTime;
        let nextPath = (imageData.root && itemNext?.filename) ? `${imageData.root}/${itemNext.filename}` : undefined;
        let prevPath = (imageData.root && itemPrev?.filename) ? `${imageData.root}/${itemPrev.filename}` : undefined;
        let path = (imageData.root && item?.filename) ? `${imageData.root}/${item.filename}` : undefined;
        const d = new Date(cvtDateTime);
        let formattedDate = `${d.toLocaleString("en-US", { month: "short" })} ${d.getDate()} ${d.getFullYear()} ${d.toTimeString().slice(0, 5)}`;
        return {
            ...imageData, currentImage: path, currentIndex: index,
            currentCvtDateTime: cvtDateTime, formattedDate, showPrev: index > 0,
            showNext: index !== imageData.times.length - 1, type: "image",
            nextPath, prevPath, cvtDateTime
        }
    }

    const onDateChange = (date, id = 0, targetCamera = selectedCamera, updateDisplay = true) => {
        if (!targetCamera?.id) return;
        // setLoading(true)
        let url = date ? `images_list/${targetCamera.id}/?date=${date}` : `images_list/${targetCamera.id}/`
        dispatch({
            type: `${LATESTFILE}_GET`,
            payload: url,
            callback: (resp) => {
                // setFile(resp);
                let utcTime = resp?.current_utc;
                let cvtDateTime = resp?.cvt_datetime;
                let times = resp?.dates_times || [];
                let root = resp?.root;
                let thumbnails = resp?.thumbnails;
                const utcMap = new Map();
                times.forEach((item, index) => {
                    utcMap.set(item.utc, index);
                });
                let imgData = { utcTime, cvtDateTime, times, root, utcMap, thumbnails }
                let formattedData = formatCurrentImage(imgData, imgData?.utcTime)
                if (formattedData) {
                    if (updateDisplay) {
                        if (id == 0) {
                            setShowImage1({ path: formattedData.currentImage, fd: formattedData?.formattedDate })
                            setImageData(formattedData)
                            setImageData2(formattedData)
                            setShowImage2({ path: formattedData.currentImage, fd: formattedData?.formattedDate })
                        } else if (id == 1) {
                            setImageData(formattedData)
                            setShowImage1({ path: formattedData.currentImage, fd: formattedData?.formattedDate })

                        } else if (id == 2) {
                            setImageData2(formattedData)
                            setShowImage2({ path: formattedData.currentImage, fd: formattedData?.formattedDate })
                        }
                    } else {
                        setImageData(prev => ({
                            ...formattedData,
                            currentImage: prev?.currentImage || formattedData.currentImage,
                            type: prev?.type || "video"
                        }));
                    }
                } else if (updateDisplay) {
                    const fallbackPath = targetCamera?.thumbnail || targetCamera?.image || "";
                    if (fallbackPath) {
                        setShowImage1({ path: fallbackPath, fd: "" });
                        setImageData({ currentImage: fallbackPath, type: "image", times: [] });
                    }
                }
            }
        });
    }
    const handleVideoChange = (data) => {
        let index = data.type == "next" ? imageData?.currentIndex + 1 : imageData?.currentIndex - 1
        let formattedData = formatCurrentImage(imageData, index)
        setImageData(formattedData)
        setShowImage1({ path: formattedData.currentImage, fd: formattedData.formattedDate })
    }
    const fetchCompareImages = (month, year) => {
        console.log(month, year)
        if (!selectedCamera) return;
        dispatch({
            type: `${LATESTDAYFILE}_POST`, // or create a new action like COMPARE_IMAGES_GET
            payload: {
                camera: selectedCamera.id,
                month,
                year
            },
        });
        // setView(9);
        console.log("API response for compare images:", monthProgressState.data)
    };

    const handlePtzAction = (direction, customParams = {}) => {
        if (!selectedCamera?.id) return;
        dispatch({
            type: `${PRESET}_POST`,
            payload: {
                id: selectedCamera.id,
                direction,
                ...customParams,
            },
        });
    };

    const isPtzActive = Boolean(
        selectedCamera?.ptz === true ||
        selectedCamera?.ptz === 1 ||
        selectedCamera?.ptz === "true" ||
        selectedCamera?.has_ptz === true
    );

    const handleOpenDeepZoom = () => {
        if ((video_mode || imageData?.type === "video") && videoViewerRef.current) {
            try {
                const snapshotUrl = videoViewerRef.current.getSnapshot();
                setSnapshotImage(snapshotUrl || null);
            } catch (e) {
                console.error("Failed to get snapshot for Deep Zoom:", e);
                setSnapshotImage(null);
            }
        } else {
            setSnapshotImage(null);
        }
        setDeepZoomOpen(true);
    };

    const handleToggleThreeDStack = () => {
        setShow3DStack((prev) => !prev);
    };

    const viewMap = {
        0: <>
            <Box className="overlay-log" sx={{ display: { xs: 'none', sm: 'block' } }}><img src={overlayLogo} height={40} /></Box>
            {!video_mode ? (
                <ImageViewer
                    ref={videoViewerRef}
                    src={showImage1?.path}
                    showPrev={imageData.showPrev}
                    showNext={imageData.showNext}
                    icons={videoIcons}
                    prevPath={imageData.prevPath}
                    nextPath={imageData.nextPath}
                    onChange={(data) => { handleVideoChange(data) }}
                    camera={selectedCamera}
                    label={selectedCamera?.camera_name}
                    showTimeline={showTimeline}
                    timelineData={imageData?.thumbnails}
                    rootPath={imageData?.root}
                    currentDate={imageData?.currentCvtDateTime?.split('T')?.[0]}
                    onCloseTimeline={() => setShowTimeline(false)}
                    onSelectTimelineDate={(date) => {
                        onDateChange(date, 1);
                    }}
                    onDeepZoom={handleOpenDeepZoom}
                    onThreeDStack={handleToggleThreeDStack}
                />
            ) : (
                <VideoViewer
                    ref={videoViewerRef}
                    src={showImage1?.path}
                    type="video"
                    camera={selectedCamera}
                    onPtz={isPtzActive ? handlePtzAction : null}
                    video_mode={true}
                    icons={videoIcons}
                    label={selectedCamera?.camera_name}
                    onChange={(data) => { handleVideoChange(data) }}
                    showTimeline={showTimeline}
                    timelineData={imageData?.thumbnails}
                    rootPath={imageData?.root}
                    currentDate={imageData?.currentCvtDateTime?.split('T')?.[0]}
                    onCloseTimeline={() => setShowTimeline(false)}
                    onSelectTimelineDate={(date) => {
                        onDateChange(date, 1);
                    }}
                    onDeepZoom={handleOpenDeepZoom}
                    onThreeDStack={handleToggleThreeDStack}
                />
            )}
        </>,
        1: <>
            <DateBar showImage1={showImage1} imageData={imageData} setShowImage1={setShowImage1}
                showImage2={showImage2} imageData2={imageData2} setShowImage2={setShowImage2}
                formatCurrentImage={formatCurrentImage}
                onClose={() => handleChangeView(0)}
            />
            <SplitPreview value={showImage1?.path || undefined} value1={showImage2?.path || undefined} />
        </>,
        2: <>
            <DateBar monthOnly={true} showImage1={showImage1} imageData={imageData} setShowImage1={setShowImage1}
                onMonthChange={fetchCompareImages} formatCurrentImage={formatCurrentImage}
                onClose={() => handleChangeView(0)}
            />
            <CompareMonth
                months={monthProgressState?.data?.results || []}
                camera={selectedCamera}
                onClose={() => handleChangeView(0)}
            />
        </>,
        3: <>
            <DateBar showImage1={showImage1} imageData={imageData} setShowImage1={setShowImage1}
                showImage2={showImage2} imageData2={imageData2} setShowImage2={setShowImage2}
                onDateChange={onDateChange} formatCurrentImage={formatCurrentImage}
                onClose={() => handleChangeView(0)}
            />
            <DiffPreview value={showImage1?.path || undefined} value1={showImage2?.path || undefined} />
        </>,
        4: <>
            <DateBar showImage1={showImage1} imageData={imageData} setShowImage1={setShowImage1}
                showImage2={showImage2} imageData2={imageData2} setShowImage2={setShowImage2}
                onDateChange={onDateChange} formatCurrentImage={formatCurrentImage}
                onClose={() => handleChangeView(0)}
            />
            <SpotCompare value={showImage1?.path || undefined} value1={showImage2?.path || undefined} date={showImage2?.fd} />
        </>,
        5: <>
            <DateBar showImage1={showImage1} imageData={imageData} setShowImage1={setShowImage1}
                showImage2={showImage2} imageData2={imageData2} setShowImage2={setShowImage2}
                onDateChange={onDateChange} formatCurrentImage={formatCurrentImage}
                onClose={() => handleChangeView(0)}
            />
            <SpotZoom image={showImage1?.path || undefined} value1={showImage2?.path || undefined} date={showImage2?.fd} />
        </>,
        6: <>
            <VectorMap markers={formatLatLng([selectedCamera], "coordinates")} />
        </>,
        12: <>
            <PDFReport camera={selectedCamera} onClose={() => setChangeView(0)} />
        </>,
        15: <>
            <Photoshop imgSrc={snapshotImage || showImage1?.path} selectedCamera={selectedCamera} onClose={() => { handleChangeView(0) }} />
        </>,
        16: <>
            <VideoPlayer2
                src={`https://demo.widelapse.com/api/video/?camera=13&date=2026-01-16T10:38:05&days=7`}
                selectedCamera={selectedCamera}
                date={`${imageData?.cvtDateTime}:00`}
                onAction={(action) => {
                    if (action == "close") {
                        handleChangeView(0)
                    }
                }}
            // src={openVideo?.video_url} data={openVideo}
            // download_name={getDownloadName(openVideo?.video_url)}
            />
        </>
    }

    const handleChangeView = (id) => {
        if (id === 100) {
            setDeepZoomOpen(true);
            return;
        }
        if (id === 101) {
            setShow3DStack((prev) => !prev);
            return;
        }
        if (imageData?.currentCvtDateTime) {
            const [year, month] = imageData?.currentCvtDateTime?.split("-").map(Number);
            fetchCompareImages(month, year);
        }
        setChangeView(id);
        if (id == 0) {
            setToolChecked(true)
        } else {
            setToolChecked(false)
        }
        console.log("hello", id)
    }
    const canToggleMode = Boolean(
        selectedCamera?.camera_type === "LIVETIMELAPSE" ||
        (
            (Boolean(selectedCamera?.stream_url) || Boolean(selectedCamera?.video_url) || selectedCamera?.camera_type === "LIVECAMERA") &&
            Boolean(imageData?.times && imageData.times.length > 0)
        )
    );

    return (
        <div>
            {(toolChecked && !showTimeline) && <Draggable>
                {/* {video_mode == "video" ? "jjj" : 'dfd'} */}
                <Stack direction="row" spacing={4} alignItems={'center'}>
                    {!video_mode && (
                        <Box className="over-menu">
                            <Box display={'flex'} alignItems={'center'} gap={1} className="open-menu">
                                <Box className="tool-menu icon-filled"><Calendar24 /></Box>
                                <Typography className="tool-text">{showImage1.fd}</Typography>
                            </Box>

                            <Box className="hover-box" sx={{ position: 'absolute' }}>
                                <Box className="hover-content">

                                    <XDateCalendar
                                        key={imageData.root}
                                        imageData={imageData}
                                        onDateChange={(date) => {
                                            onDateChange(date, 1)
                                        }}
                                        onAction={(action, value) => {
                                            if (action == "date" && value?.utc) {
                                                let formattedData = formatCurrentImage(imageData, value?.utc)
                                                setShowImage1({
                                                    path: formattedData?.currentImage + "?t=" + new Date().getTime(),
                                                    fd: formattedData?.formattedDate
                                                })
                                            } else if (action == "timeline") {
                                                setShowTimeline(true)
                                            } else if (action == "most-recent") {
                                                onDateChange(undefined, 1)
                                            }
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    )}
                    <Box sx={resposive}>
                        {!showMenu && <FaChevronRight style={{ cursor: 'pointer' }} onClick={() => setShowMenu(true)} />}
                        {showMenu && <FaChevronLeft style={{ cursor: 'pointer' }} onClick={() => setShowMenu(false)} />}
                    </Box>

                    {(showMenu) && <Stack sx={resposive} className="icon-filled" direction="row" spacing={4} alignItems={'center'}>
                        {!video_mode && <DropDown icon={<SplitViewBlackIcon />} text="Image Analysis">
                            <Box display={'flex'} gap={1} sx={{ flexWrap: 'wrap', justifyContent: 'center', rowGap: 2, columnGap: 1, py: 2 }} >
                                {viewsIcon?.map(([label, vui, icon], i) => {
                                    return <Box sx={{ width: 90 }} alignItems={'center'} justifyContent={'center'} display={'flex'} flexDirection='column'>
                                        <Box onClick={() => handleChangeView(vui)} title={label} key={i} sx={{ color: 'black' }} className="tool-menu tool-submenu">
                                            {icon}
                                        </Box>
                                        <Typography fontSize={12} >{label}</Typography>
                                    </Box>
                                })}
                            </Box>
                        </DropDown>}
                        <DropDown icon={<Weather24 title="Weather" />} text="Weather">

                            <div className="whether-blue-shade">
                                <WeatherCard height={'auto'} headHeight={98} location={{
                                    country_name: selectedCamera?.country_name,
                                    "name": selectedCamera?.camera_name,
                                    "lat": selectedCamera?.coordinates?.split(',')?.[0],
                                    "lon": selectedCamera?.coordinates?.split(',')?.[1],
                                    country_code: selectedCamera?.country,
                                }}
                                    locationName={selectedCamera?.project_country_name}
                                    location1={selectedCamera?.coordinates}
                                />
                            </div>
                        </DropDown>

                        <Box className="over-menu" onMouseEnter={() => {
                            if (imageData?.type === "video" && videoViewerRef.current) {
                                const snapshotUrl = videoViewerRef.current.getSnapshot();
                                if (snapshotUrl) {
                                    setSnapshotImage(snapshotUrl);
                                } else {
                                    setSnapshotImage(null);
                                }
                            } else {
                                setSnapshotImage(null);
                            }
                        }}>
                            <DropDown icon={<Share24 />} text="Share">
                                <Box display={'flex'} sx={{ flexWrap: 'wrap', justifyContent: 'center', rowGap: 2, columnGap: 0.5, py: 2 }} >
                                    {/* {shareIcon?.map(([label, vui, icon], i) => {
                                        return <Box onClick={() => handleChangeView(vui)} title={label} key={i} sx={{ color: 'black' }} className="tool-menu">{icon}</Box>
                                    })} */}
                                    <ShareBox
                                        keepMenu={[2, 3, 4, 5]}
                                        url={snapshotImage || showImage1?.path}
                                        icons={shareIcon.map(([label, vi, icon]) => {
                                            if ([9, 10, 11, 12].includes(vi)) {
                                                if ([12].includes(vi)) {
                                                    return (<Box sx={{ width: 88 }} alignItems={'center'} justifyContent={'space-around'} display={'flex'} flexDirection='column'>
                                                        <Box onClick={() => { setChangeView(12) }} title={label} className="tool-menu tool-submenu">{icon}</Box>
                                                        <Typography fontSize={12} >{label}</Typography>
                                                    </Box>)
                                                }
                                                const fileName = `${selectedCamera.camera_name}-${showImage1.fd}.jpg`
                                                if ([11, 14].includes(vi)) return (<Box sx={{ width: 88 }} alignItems={'center'} justifyContent={'space-around'} display={'flex'} flexDirection='column'>
                                                    <Box onClick={() => { printImage(showImage1?.path, overlayLogo, (vi == 9 ? "" : showImage1.fd), fileName, selectedCamera.camera_name) }} title={label} className="tool-menu tool-submenu">{icon}</Box>
                                                    <Typography fontSize={12} >{label}</Typography>

                                                </Box>)
                                                return <Box sx={{ width: 88 }} alignItems={'center'} justifyContent={'space-around'} display={'flex'} flexDirection='column'>
                                                    <Box onClick={() => { downloadImage(showImage1?.path, overlayLogo, (vi == 9 ? "" : showImage1.fd), fileName) }} title={label} className="tool-menu tool-submenu">{icon}</Box>
                                                    <Typography fontSize={12} textAlign={'center'} dangerouslySetInnerHTML={{ __html: label }}></Typography>

                                                </Box>
                                            }
                                            return <Box sx={{ width: 88 }} alignItems={'center'} justifyContent={'space-around'} display={'flex'} flexDirection='column'>
                                                <Box title={label} className="tool-menu tool-submenu">{icon} </Box>
                                                <Typography fontSize={12} >{label}</Typography>
                                            </Box>
                                        })}
                                        onSubmit={(data, reset) => {
                                            if (snapshotImage || showImage1?.path) {
                                                data["camera"] = selectedCamera.id
                                                data["timestamp"] = showImage1?.fd
                                                data["message"] = `${selectedCamera?.company_name}/${selectedCamera?.project_name}/${selectedCamera?.camera_name}`
                                                data["img_url"] = snapshotImage || showImage1?.path
                                                dispatch({ type: SENDEMAIL + "_POST", payload: data })
                                                reset()
                                            }
                                        }}
                                    />
                                </Box>
                            </DropDown>
                        </Box>

                        <Box display={'flex'} alignItems={'center'} gap={1} >
                            <Box className="tool-menu pointer" onClick={() => {
                                if (imageData?.type === "video" && videoViewerRef.current) {
                                    try {
                                        const snapshotUrl = videoViewerRef.current.getSnapshot();
                                        setSnapshotImage(snapshotUrl || null);
                                    } catch (e) {
                                        console.error("Failed to get snapshot:", e);
                                        setSnapshotImage(null);
                                    }
                                } else {
                                    setSnapshotImage(null);
                                }
                                handleChangeView(15)
                            }}><Markup24 /></Box>
                            <Typography className="tool-text">Markup</Typography>
                        </Box>
                        {!video_mode && <Box display={'flex'} alignItems={'center'} gap={1} >
                            <Box className="tool-menu" onClick={() => { handleChangeView(16) }}><Timelapse24 /></Box>
                            <Typography className="tool-text">Timelapse</Typography>
                        </Box>}
                    </Stack>}


                </Stack>
            </Draggable>}
            <TopBar
                homeIcon={<FaHome size={18} />}
                sepIcon={<FaChevronRight />}
                video_mode={video_mode}
                setVideoMode={setVideoMode}
                canToggleMode={canToggleMode}
                selectedCamera={selectedCamera}
                cameras={cameras}
                setSelectedCamera={setSelectedCamera}
                navigate={navigate}
                checkState={setToolChecked}
                checkStatus={toolChecked}
            />

            <Box sx={{ height: "calc(100vh - 60px)", overflow: "hidden" }}>
                {viewMap[changeView]}
            </Box>

            <DeepZoomModal
                open={deepZoomOpen}
                onClose={() => setDeepZoomOpen(false)}
                imageUrl={snapshotImage || showImage1?.path || imageData?.currentImage || selectedCamera?.thumbnail || selectedCamera?.image}
                title={`${selectedCamera?.camera_name || "Camera"} - Deep Zoom & AI Super-Pixel`}
            />

            <ThreeDStackViewer
                open={show3DStack}
                onClose={() => setShow3DStack(false)}
                images={imageData?.times || []}
                currentIndex={imageData?.currentIndex || 0}
                root={imageData?.root || ""}
                cameraName={selectedCamera?.camera_name || "Camera"}
                date={showImage1?.fd || imageData?.currentCvtDateTime?.split('T')?.[0] || ""}
                onSelectImage={(item, index) => {
                    let formattedData = formatCurrentImage(imageData, index);
                    if (formattedData) {
                        setImageData(formattedData);
                        setShowImage1({
                            path: formattedData.currentImage,
                            fd: formattedData.formattedDate
                        });
                    }
                }}
            />
        </div >
    );
}
